import {useEffect, useRef} from "react";
import {CheckCircleIcon} from "@heroicons/react/24/outline";

const VISIBLE_FOR_MS = 3000;

interface PanelTaskMessageProps {
    message: string | null;
    onDismiss: () => void;
}

export function PanelTaskMessage({message, onDismiss}: PanelTaskMessageProps) {
    const onDismissRef = useRef(onDismiss);
    onDismissRef.current = onDismiss;

    useEffect(() => {
        if (!message) return;
        const timer = window.setTimeout(() => onDismissRef.current(), VISIBLE_FOR_MS);
        return () => window.clearTimeout(timer);
    }, [message]);

    if (!message) return null;

    return (
        <div
            role="status"
            aria-live="polite"
            className="mb-3 flex items-start gap-x-2 rounded-lg bg-green-50 px-3 py-2 text-sm text-green-800 ring-1 ring-inset ring-green-200"
        >
            <CheckCircleIcon className="mt-0.5 size-4 shrink-0 text-green-600" aria-hidden="true" />
            <span>{message}</span>
        </div>
    );
}
